import { render, staticRenderFns } from "./Shows.vue?vue&type=template&id=2f92b3fe&scoped=true&"
import script from "./Shows.vue?vue&type=script&lang=js&"
export * from "./Shows.vue?vue&type=script&lang=js&"
import style0 from "./Shows.vue?vue&type=style&index=0&id=2f92b3fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f92b3fe",
  null
  
)

export default component.exports